import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { Nav, NavItem } from 'react-bootstrap/lib';
import { LinkContainer } from 'react-router-bootstrap/lib';
import { UserRole } from '@upstart/harmony/lib/constants';
import SidebarContainer from '../SidebarContainer';
import ErrorMessage from '../../components/ErrorMessage';
import feedviewsActions from '../../redux/feedviews/actions';
import { getFeedview } from '../../redux/feedviews/selectors';
import './Feedview.scss';

import FeedviewConfig from '../../components/Feedview/FeedviewConfig';
import FeedviewFilters from '../../components/Feedview/FeedviewFilters';

function FeedviewContainer(props) {
  const { feedviewId } = props.match.params;
  const { actions, feedview, error } = props;

  useEffect(() => {
    if (feedviewId) {
      // If feedviewId is present in URL
      // Let's fetch that Feedview
      actions.feedviewRequest({ feedviewId });
    } else {
      // feedviewId is null
      // Assume Create mode
      // Reset feedview in state
      actions.resetFeedview({});
    }
  }, [actions, feedviewId]);

  const menu = [
    {
      name: 'Config',
      getUrl: id => (id ? `/feedview/${id}/config` : `/feedview`),
      roles: [
        UserRole.SUPER_ADMIN,
        UserRole.ADMIN,
        UserRole.READ_ONLY_ADMIN,
        UserRole.DEALER_ADMIN,
        UserRole.LIMITED_DEALER_ADMIN,
      ],
    },
  ];

  if (feedview.id) {
    menu.push({
      name: 'Filters',
      getUrl: id => `/feedview/${id}/filters`,
      roles: [
        UserRole.SUPER_ADMIN,
        UserRole.ADMIN,
        UserRole.READ_ONLY_ADMIN,
        UserRole.DEALER_ADMIN,
        UserRole.LIMITED_DEALER_ADMIN,
      ],
    });
  }

  const renderMenuItem = item => {
    const url = item.getUrl(feedviewId);
    return (
      <LinkContainer to={url} key={url}>
        <NavItem>{item.name}</NavItem>
      </LinkContainer>
    );
  };

  const title =
    feedview.id && feedview.name
      ? `Modify Feedview: ${feedview.name}`
      : `Create Feedview`;

  return (
    <SidebarContainer title={title} openSubMenu="Inventory">
      <div className="feedview-page-contianer">
        {error && <ErrorMessage error={error} />}
        <Nav bsStyle="tabs">{menu.map(renderMenuItem)}</Nav>
        {props.isConfigRoute && (
          <FeedviewConfig feedview={{ ...feedview }} history={props.history} />
        )}
        {feedview && props.isFiltersRoute && (
          <FeedviewFilters
            feedview={{ ...feedview }}
            history={props.history}
            match={props.match}
          />
        )}
      </div>
    </SidebarContainer>
  );
}

FeedviewContainer.propTypes = {
  feedview: PropTypes.object,
  actions: PropTypes.object,
  match: PropTypes.object,
  isConfigRoute: PropTypes.bool,
  isFiltersRoute: PropTypes.bool,
  history: PropTypes.object,
};

const mapStateToProps = state => ({
  feedview: getFeedview(state),
  feedviews: state.feedviews,
  error: state.feedviews.error,
  dealer: state.dealers.dealer,
  user: state.user.currentUser,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      ...feedviewsActions,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(FeedviewContainer);
